<template>
	<div>
		<!-- 头部 -->
		<div class="head">
			<div>
				<div class="left">LOGO</div>
				<div class="right">
					<div>
						<ul class="nav">
							<li><a href="">主机</a></li>
							<li><a href="">个人中心</a></li>
							<li><a href="">首页</a></li>
							<li><a href="">首页</a></li>
							<li><a href="">首页</a></li>
							<li><a href="">首页</a></li>
						</ul>
					</div>
					<div class="sear">
						<text class='search'></text>
						<input type="text" v-model="inputVal" :class="[{ inpuActive: isActive }]"  @mouseover ='inpuMouSeover' @mouseleave="inputMouseLeave"  @change="subSeach"/>
					</div>
				</div>
			</div>
		
		</div>
		<!-- 头部结束 -->
		<div class="brann">
			<img src="../assets/brann.jpg" alt="">
		</div>
		<!-- 内容 -->
		<div class="jianjieCon">
			<div class="Ttl">液态饲喂</div>
			<div class="conters">
				<div class="jjLeft">
						<ul>
							<li class="lItem" :class="{active:lLindex == index}" v-for="(item,index) in Llist" @click="LTab(index)">凉白开平台 <span class="iconfont icon-iconfontjiantou5"></span> </li>
						</ul>
					</div>
					<div class="jjRight">
						<ul>
							<li class="rItem" v-for="item in RList">
								<a href=""><img src="../assets/1431335355535.jpg" /></a> 
								<p>名称名称名称名称名称名称名称名称名称名称名称名称名称名称名称名称</p>
							</li>
							
						</ul>
						<!-- 分页 -->
						<div class="fenye">
							<el-pagination
							    layout="prev, pager, next"
							    :total="50">
							 </el-pagination>
						</div>
					</div>
			</div>
			
			
		</div>
		
	</div>

</template>

<script>
	export default{
		name:'homePage',
		data(){
			return{
				isActive:false,
				inputVal:'',
				RList:[1,1,1,1,1,1,1],
				lLindex:0,
				Llist:['凉白开平台','凉白开平台','凉白开平台','凉白开平台','凉白开平台','凉白开平台','凉白开平台']
			}			
		},
		methods:{
			// 鼠标移入sear
			inpuMouSeover:function(){
				this.isActive = true
			},
			// 失去焦点
			shiqu:function(){
				if(this.inputVal ==''){
					this.isActive = false
				}
			},
			// 鼠标移出sear
			inputMouseLeave:function(){
			
			},
		
			// 提交搜索
			subSeach:function(e){
				console.log(e)
				// this.$router.push('/search')
			},
			// 左边的tab
			LTab:function(index){
				this.lLindex = index
			}
		},

	}
</script>

<style scoped>
	ul{
		padding: 0px;
		margin: 0px;
	}
	li{
		list-style: none;
	}
	.fenye{
		margin: 20px 0px 0px ;
		text-align: center;
	}
	.brann{
		width: 100%;
		height: 240px;
		margin: 80px 0px 0px;
	}
	.brann>img{
		width: 100%;
		height:100%;
	}
	
	
	.jianjieCon{
		margin: 50px auto 30px;
		width: 1000px;
		box-sizing: border-box;
	}
	.conters{
		display: flex;
		justify-content: flex-start;
	}
	.conters>.jjLeft li{
		width: 200px;
		padding: 20px 0px 10px;
		border-bottom: 1px solid #EEEEEE;
		text-align: left;
		font-size: 14px;
		color: #6C6C6C;
		letter-spacing: 1px;
		position: relative;
		cursor: pointer;
	}
	.conters>.jjLeft li>span{
		display: inline-block;
		width: 15px;
		height:15px;
		position: absolute;
		right: 20px;
		background-image: url(../assets/rightjt.png);
		background-size: 100% 100%;
		background-position: center center;
	}
	.conters>.jjLeft li.active,.jjLeft li.active .icon-iconfontjiantou5,.conters>.jjLeft li:hover,.jjLeft li:hover .icon-iconfontjiantou5{
		color: red;
	}
	
	.Ttl{
		width: 100px;
		text-align: left;
		color: #333333;
		font-weight: bold;
		font-size: 18px;
		border-bottom: 2px solid red;
		padding-bottom: 5px;
	}
	.jjRight ul{
		display: flex;
		justify-content: flex-start;
		flex-direction: row;
		flex-wrap: wrap;
	}
	.jjRight{
		margin-left: 30px;
	}
	.jjRight .rItem{
		width: 220px;
		margin: 20px 10px;
	}
	.jjRight .rItem p{
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin: 5px 0px 0px ;
		font-size: 16px;
		letter-spacing: 1px;
	}
	.jjRight .rItem a{
		width: 100%;
		padding: 5px;
	}
	.jjRight .rItem img{
		width: auto;
		max-width: 100%;
	}
	/* 头部 */
	.head{
			width: 100%;
			height: 80px;
			line-height: 80px;		
			font-size: 14px;
			font-weight: 600;
			position: fixed;
			top: 0px;
			left: 0px;
			background-color: white;
			z-index: 30;
			box-shadow: 1px 1px 0.5px #EEEEEE;
		}
		.head>div{
			width: 1200px;
			margin: auto;
			display: flex;
			box-sizing: border-box;
			flex-direction: row;
			justify-content: space-between;
		}
		.head .left{
			
			width: 150px;
			background-color: rgb(39,85,161);
			color: white;
		}
		.head .right{
				display: flex;
				align-items: center;
		}
		.head .right .nav{
			width: 600px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin: 0px 20px 0px auto;
		}
		.head .right .nav li a{
			padding: 10px 0px;
		}
		
	.head	.right .nav li:hover>a{
			border-bottom: 1px solid rgb(39,85,161);
		}
	.head	.right .sear{
			margin: 0px 10px;
			width: 160px;
			text-align: left;
		}
	.head	.right .sear>input{
			width: 40px;
			background-color:#4876FF;
			color: white;
			border: 0px;
			outline: inherit;
			height: 25px;
			line-height: 25px;
			border-radius: 20px;
			background-image: url(../assets/sear.png);
			background-size: 15px 15px;
			background-repeat: no-repeat;
			background-position: 10px 4px;
			cursor:pointer;
			transition: all 1s;
			padding-left: 30px;
		}
</style>



// WEBPACK FOOTER //
// src/components/jianjie.vue